<template>
  <div>
    <MainCard v-if="!isLoadingTable">
      <template v-slot:body>
        <DataTablePagination
          :page="page"
          :total-items="totalItems"
          :headers="headers"
          :items="violations"
          :search="search"
          :is-loading="isLoadingData"
          title="Jenis Pelanggaran"
          subtitle="Halaman untuk menambahkan jenis pelanggaran"
          add-btn="Tambah Data"
          :total-pages.sync="totalPages"
          @add-item="showFormAdd"
          @edit-item="showFormEdit"
          @delete-item="confirmDestroy"
          @page="page"
          @change-page="paginationHandler"
          @live-search="searchHandler"
        >
        </DataTablePagination>
      </template>
    </MainCard>
    <SkeletonLoaderTable v-else></SkeletonLoaderTable>
    <ModalDialog
      :visible="modalDialog"
      :width="width"
      :is-loading-button="isLoadingButton"
      :is-disabled-button="!violationType.name || !violationType.point"
      :dialog="dialog"
      :header="dialog === 'add' ? 'Tambah Pelanggaran': 'Edit Pelanggaran'"
      :text-button="dialog === 'add' ? 'Tambah': 'Update'"
      @handler-button="handlerButton"
      @close-modal="modalDialog = false"
      @close-button="modalDialog = false"
    >
      <template v-slot:body>
        <div>
          <v-text-field
            v-model="violationType.name"
            label="Pelanggaran"
            dense
            outlined
            type="text"
          ></v-text-field>
        </div>
        <div>
          <v-text-field
            v-model="violationType.point"
            label="Poin"
            dense
            type="number"
            outlined
          ></v-text-field>
        </div>
      </template>
    </ModalDialog>
    <ConfirmDialog
      :visible="confirmDialog"
      :is-loading-button="isLoadingButton"
      header="Hapus Pelanggaran"
      @close-button="confirmDialog = false"
      @destroy-button="destroy"
    >
    </ConfirmDialog>
  </div>
</template>

<script>
import ConfirmDialog from '@/views/components/ConfirmDialog.vue'
import DataTablePagination from '@/views/components/DataTablePagination.vue'
import MainCard from '@/views/components/MainCard.vue'
import ModalDialog from '@/views/components/ModalDialog.vue'
import SkeletonLoaderTable from '@/views/components/SkeletonLoaderTable.vue'

export default {
  name: 'ViolationType',
  components: {
    DataTablePagination,
    ModalDialog,
    ConfirmDialog,
    SkeletonLoaderTable,
    MainCard,
  },
  data() {
    return {
      page: 1,
      totalItems: 0,
      totalPages: 0,
      dialog: null,
      search: '',
      isLoadingTable: true,
      isLoadingButton: false,
      isLoadingData: false,
      modalDialog: false,
      confirmDialog: false,
      width: 600,
      service: 'violation',
      violations: [],
      violationType: {
        school_uuid: '',
        name: '',
        point: '',
      },
      headers: [
        { text: 'No', value: 'index' },
        { text: 'Poin', value: 'point' },
        { text: 'Jenis Pelanggaran', value: 'name' },
        { text: 'Aksi', value: 'actions' },
      ],
      school: '',
      school_uuid: '',
      user_uuid: '',
      filterQuery: {
        search: '',
      },
      formValid: false,
    }
  },
  watch: {
    page: {
      handler() {
        this.listViolation(this.filterQuery)
      },
    },
  },
  async mounted() {
    this.getSchoolUuid()
    this.isLoadingTable = true
    await this.listViolation()
    this.isLoadingTable = false
  },
  methods: {
    getSchoolUuid() {
      this.school = JSON.parse(localStorage.getItem('user')).user.details
      this.school.forEach(el => {
        if (el.school === undefined) {
          this.violationType.school_uuid = el.uuid
          this.school_uuid = el.uuid

          return
        }
        if (el.school === null) {
          this.showSnackbar({
            text: "You don't have access to school",
            color: 'error',
          })

          return
        }
        this.violationType.school_uuid = el.school.uuid
      })

      return true
    },

    async listViolation(params = {}) {
      this.isLoadingData = true
      await this.$services.ApiServices.list(this.service, {
        ...params,
        school_uuid: this.school_uuid,
        page: this.page,
      }).then(
        ({ data }) => {
          this.violations = data.data.map((violations, index) => ({
            ...violations,
            index: index + 1,
          }))
          this.totalPages = data.meta.last_page
          this.totalItems = data.meta.total
        },
        err => {
          console.error(err)
        },
      )
      this.isLoadingTable = false
      this.isLoadingData = false
    },

    resetForm() {
      this.violationType.uuid = ''
      this.violationType.name = ''
      this.violationType.point = ''
    },

    showSnackbar(snackbarData) {
      this.$store.dispatch('snackbar/showSnackbar', snackbarData)
    },

    showFormAdd() {
      this.dialog = 'add'
      this.resetForm()
      this.modalDialog = true
    },

    async add() {
      this.isLoadingButton = true
      await this.$services.ApiServices.add(this.service, this.violationType).then(
        ({ data }) => {
          this.showSnackbar({
            text: data.result.message,
            color: 'success',
          })
          this.isLoadingButton = false
          this.modalDialog = false
          this.resetForm()
          this.listViolation(this.filterQuery)
        },
        err => {
          this.isLoadingButton = false
          console.error(err)
        },
      )
    },
    async showFormEdit(uuid) {
      this.dialog = 'edit'
      this.violationType.uuid = uuid
      await this.$services.ApiServices.get(this.service, uuid).then(
        ({ data }) => {
          this.violationType.school_uuid = data.data.school.uuid
          this.violationType.name = data.data.name
          this.violationType.point = data.data.point
        },
        err => console.error(err),
      )
      this.modalDialog = true
    },

    async update() {
      this.isLoadingButton = true
      await this.$services.ApiServices.update(this.service, this.violationType, this.violationType.uuid).then(
        ({ data }) => {
          this.listViolation(this.filterQuery)
          this.resetForm()
          this.showSnackbar({
            text: data.result.message,
            color: 'success',
          })
          this.modalDialog = false
        },
        err => {
          this.isLoadingButton = false
          console.error(err)
        },
      )
      this.isLoadingButton = false
    },

    confirmDestroy(uuid) {
      this.confirmDialog = true
      this.violationType.uuid = uuid
    },

    async destroy() {
      this.isLoadingButton = true
      await this.$services.ApiServices.destroy(this.service, this.violationType.uuid).then(({ data }) => {
        this.listViolation(this.filterQuery)
        this.showSnackbar({
          text: data.result.message,
          color: 'success',
        })
      })
      this.isLoadingButton = false
      this.confirmDialog = false
    },
    handlerButton() {
      if (this.dialog === 'add') this.add()
      else this.update()
    },

    paginationHandler(pageNumber) {
      this.page = pageNumber
    },

    searchHandler(search) {
      this.filterQuery.search = search
      this.page = 1
      this.listViolation(this.filterQuery)
    },
  },
}
</script>

<style>
</style>
